export default __webpack_public_path__ + "static/media/mongodb_original_logo_icon_146424.7a16fc61.png";